import { render, staticRenderFns } from "./UppsalaVatten.vue?vue&type=template&id=b6c4a75a&scoped=true&"
import script from "./UppsalaVatten.vue?vue&type=script&lang=js&"
export * from "./UppsalaVatten.vue?vue&type=script&lang=js&"
import style0 from "./UppsalaVatten.vue?vue&type=style&index=0&id=b6c4a75a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b6c4a75a",
  null
  
)

export default component.exports